const desktop = theme => {
  const {toVW} = theme;
  return {
    rectangularButton: {
      // otherwise: overlap with player at the top in all-in table
      width: '10vw',
    },
    currentPotBox: {
      '&.dynamicHeight': {
        fontSize: '1.25vw',
        height: '3vw',
        '& img': {
          // for card's suit
          height: '1vw',
        },
      },
    },
    verticalCard: {
      '&.dynamicHeight': {
        height: '100%',
        justifyContent: 'space-around',
      },
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    topButton: {
      border: 'none',
      color: theme.textColor,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '11px',
      textAlign: 'center',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      borderRadius: '10px',
      height: 40,
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        color: theme.textColor,
      },
    },
    rectangularButton: {
      extend: 'topButton',
      width: 'calc((100vw - 30px) / 4)',
      '&.highlighted': {
        border: '2px white solid',
      },
      '&.hasAlert': {
        '&::after': {
          content: '""',
          backgroundImage: 'url(/icon/menu/alert.svg)',
          backgroundSize: '12px 12px',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          left: -3,
          top: -3,
          width: 12,
          height: 12,
        },
      },
    },
    bubbleHandsContainer: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      '& > div:not(:last-child)': {
        marginRight: '3px',
      },
      '& img': {
        marginLeft: '1px',
        height: '10px',
        position: 'relative',
        top: 1.5,
      },
      '& .rank': {
        position: 'relative',
        top: '1px',
      },
    },
    verticalCard: {
      display: 'flex',
      flexDirection: 'column-reverse',
      lineHeight: '11px',
      '& > .rank': {
        position: 'relative',
        // top: '-8px',
      },
      '& > .suit': {
        position: 'relative',
        // top: '-3px',
      },
    },
    currentPotBox: {
      extend: 'rectangularButton',
      zIndex: 0,
      backgroundColor: 'none',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 0, 0, 0.25)',
        color: theme.textColor,
      },
      fontSize: '12px',
      '&.showingHands': {
        fontFamily: 'Helvetica Neue LT Std, sans-serif',
        fontWeight: 700,
      },
      lineHeight: '18px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    tournamentIcon: {
      position: 'absolute',
      right: 0,
      top: '-1px',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
